<tr [ngClass]="{'option_row--set': itemTree.extraRoles.length > 0}">
  <td easEditorBookingItemInheritableTypeHeader [inheritableType]="itemTree.extraRoles.length === 0 ? 'empty' : 'set'" i18n>
    Restricted roles with access to this bookable item
  </td>
  <td>
    @if (itemTree.extraRoles.length === 0) {
      <span class="text-muted" i18n>
      Not set
    </span>
    }
    @if (itemTree.extraRoles.length > 0) {
      <span>
        {{ extraRolesNamesAsString }}
      </span>
    }
    <button mat-icon-button
      aria-label="Edit extra roles"
      i18n-aria-label
      (click)="onEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </td>
  <td>
    @if (itemTree.extraRoles.length > 0) {
      <eas-editor-booking-item-inheritable-type-badge [inheritableType]="'set'">
      </eas-editor-booking-item-inheritable-type-badge>
    }
  </td>
</tr>
